import { createReducer, INITIAL_STATE, Type } from 'store/utils';
import { GET_ORGANIZATIONS_ACTIONS } from './constants';

export const initialState = {
  get: {
    ...INITIAL_STATE,
    data: [],
  },
};

const getOrganizationsMapper: Type[] = [
  {
    type: GET_ORGANIZATIONS_ACTIONS.START,
    mapper: ({ get, ...state }) => ({
      ...state,
      get: {
        ...get,
        loading: true,
      },
    }),
  },
  {
    type: GET_ORGANIZATIONS_ACTIONS.FAIL,
    mapper: ({ get, ...state }, { error }) => ({
      ...state,
      get: {
        ...get,
        loading: false,
        loaded: true,
        error,
      },
    }),
  },
  {
    type: GET_ORGANIZATIONS_ACTIONS.SUCCESS,
    mapper: ({ get, ...state }, { data }) => ({
      ...state,
      get: {
        ...get,
        loading: false,
        loaded: true,
        error: null,
        data,
      },
    }),
  },
  {
    type: GET_ORGANIZATIONS_ACTIONS.RESET,
    mapper: ({ get, ...state }) => ({
      ...state,
      get: initialState.get,
    }),
  },
];

export default createReducer({ types: getOrganizationsMapper, initialState });
